<i class="fa fa-info-circle fs-lg f-gray flip-x pointer" containerClass="tooltip-info" triggers="focus"
	tabindex="0" [tooltip]="hint" placement="right"></i>
<ng-template #hint>
	<ng-content></ng-content>
</ng-template>